/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ChallengeType } from './ChallengeType';
import {
    ChallengeTypeFromJSON,
    ChallengeTypeFromJSONTyped,
    ChallengeTypeToJSON,
} from './ChallengeType';
import type { TOTPRegisterAttestationData } from './TOTPRegisterAttestationData';
import {
    TOTPRegisterAttestationDataFromJSON,
    TOTPRegisterAttestationDataFromJSONTyped,
    TOTPRegisterAttestationDataToJSON,
} from './TOTPRegisterAttestationData';

/**
 * 
 * @export
 * @interface TOTPRegisterAttestation
 */
export interface TOTPRegisterAttestation {
    /**
     * 
     * @type {string}
     * @memberof TOTPRegisterAttestation
     */
    challenge_id: string;
    /**
     * 
     * @type {ChallengeType}
     * @memberof TOTPRegisterAttestation
     */
    challenge_type: ChallengeType;
    /**
     * 
     * @type {TOTPRegisterAttestationData}
     * @memberof TOTPRegisterAttestation
     */
    data?: TOTPRegisterAttestationData;
}

/**
 * Check if a given object implements the TOTPRegisterAttestation interface.
 */
export function instanceOfTOTPRegisterAttestation(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "challenge_id" in value;
    isInstance = isInstance && "challenge_type" in value;

    return isInstance;
}

export function TOTPRegisterAttestationFromJSON(json: any): TOTPRegisterAttestation {
    return TOTPRegisterAttestationFromJSONTyped(json, false);
}

export function TOTPRegisterAttestationFromJSONTyped(json: any, ignoreDiscriminator: boolean): TOTPRegisterAttestation {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'challenge_id': json['challenge_id'],
        'challenge_type': ChallengeTypeFromJSON(json['challenge_type']),
        'data': !exists(json, 'data') ? undefined : TOTPRegisterAttestationDataFromJSON(json['data']),
    };
}

export function TOTPRegisterAttestationToJSON(value?: TOTPRegisterAttestation | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'challenge_id': value.challenge_id,
        'challenge_type': ChallengeTypeToJSON(value.challenge_type),
        'data': TOTPRegisterAttestationDataToJSON(value.data),
    };
}

